import React from 'react';
import { Menu, MenuProps } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import paths from 'routes/paths';


const MainNav: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = paths
        .filter(({ icon }) => icon)
        .map(({ key, label, icon: Icon, path }) => ({
            key: path,
            label,
            icon: Icon && <Icon />
        })) as MenuProps['items'];

    return (
        <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            onClick={({ key }) => navigate(key)}
            items={menuItems}
            className="main-nav"
        />
    );
};

export default MainNav; 